export const homeTypes = {
    getKpis: '[HOME] Get kpis',
    getFeaturedInvestors: '[HOME] Get Featured Investors',
    getSavedInvestors: '[HOME] Get Saved Investors',
    getMatchActivityHome: '[HOME] Get Match activity',
    sendRequestInvestor: '[SAVED INVESTOR] send request',
    deleteSavedInvestor: '[SAVED INVESTOR] delete investor',
}